<template>
  <v-card>
    <v-card-title>表示順変更</v-card-title>
    <v-card-text>
      <draggable
        v-model="changeGalleries"
        class="p-imageCard__block"
        ghost-class="ghost"
        handle=".p-imageCard__handle"
        :force-fallback="true"
        :scroll-sensitivity="150"
        tag="v-row"
        :animation="200"
      >
        <div
          v-for="(gallery, index) in changeGalleries"
          :key="gallery.id"
          class="d-flex child-flex p-imageCard__handle"
          style="padding: 3px; width: 33%"
        >
          <ExhibitBlockLayout
            :src="gallery.file"
            width="100%"
            height="0"
            paddingBottom="100%"
          >
            <span class="p-imageCard__priority">
              {{ index + 1 }}
            </span>
            <span style='position: absolute; right: 0'>
            <v-chip
              v-if="gallery.published"
              color="green"
              style="color: white"
              class="ma-2"
              >公開</v-chip
            >
            <v-chip v-else color="red" style="color: white" class="ma-2"
              >非公開</v-chip
            >
            </span>
          </ExhibitBlockLayout>
        </div>
      </draggable>
    </v-card-text>
  </v-card>
</template>

<script>
import draggable from 'vuedraggable'
import ExhibitBlockLayout from '@/components/commons/exhibits/ExhibitBlockLayout'

export default {
  components: {
    draggable,
    ExhibitBlockLayout
  },
  props: {
    galleries: {
      type: Array,
      required: true
    }
  },
  computed: {
    changeGalleries: {
      get () {
        return this.$props.galleries
      },
      set (value) {
        this.$emit('change', value)
      }
    }
  }
}
</script>
